import React, { useState, useCallback } from "react";
import { RendererProps } from "./index";
import { ChoiceList, ChoiceOption } from "./renderer-styles";

const ChoiceMultiRenderer: React.FC<RendererProps> = ({
  question,
  answer,
  onAnswer,
}) => {
  const [selectedValues, setSelectedValues] = useState<string[]>(() => {
    if (answer?.values) {
      return answer.values.map((v: any) => v.value);
    }
    return [];
  });

  const handleToggle = useCallback(
    (value: string) => {
      setSelectedValues((prev) => {
        const next = prev.includes(value)
          ? prev.filter((v) => v !== value)
          : [...prev, value];
        onAnswer(
          null,
          next.length > 0,
          next.map((v) => ({ value: v }))
        );
        return next;
      });
    },
    [onAnswer]
  );

  return (
    <ChoiceList>
      {(question.choices || []).map((choice) => (
        <ChoiceOption
          key={choice.value}
          selected={selectedValues.includes(choice.value)}
        >
          <input
            type="checkbox"
            value={choice.value}
            checked={selectedValues.includes(choice.value)}
            onChange={() => handleToggle(choice.value)}
          />
          {choice.title || choice.label}
        </ChoiceOption>
      ))}
    </ChoiceList>
  );
};

export default ChoiceMultiRenderer;
